import { useMemo } from 'react';
import { ColumnDef } from '@tanstack/react-table';

import { Activity } from '../../../../types';
import { activitiesTableColumns } from '../../activitiesTableColumns';

export const useActivitiesTable = () => {
  const columns = useMemo<ColumnDef<Activity>[]>(
    () => activitiesTableColumns,
    [],
  );

  return {
    columns,
  };
};
